module.exports = __webpack_public_path__ + "components/rewards/ski-line/static/logo-543c09a70d7b0ebbb04c58067a26adf4.jpg";